import { Component, OnInit, Input, OnChanges, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { WindowResizeService } from '../../window-resize.service';


@Component({
    selector: 'internal-links',
    templateUrl: './internal-links.component.html',
    styleUrls: ['./internal-links.component.scss']
})
export class InternalLinks implements OnInit, OnChanges, OnDestroy {
    @Input() items: any[];
    @Input() title: string;
    public itemsCarousel: any[];
    public indexLess: number;
    public indexMore: number;
    public btnLess: boolean;
    public btnMore: boolean;
    public deviceType: string;
    public carouselItemsClass: string;
    public isNode: boolean = false;
    public isFliped: boolean = false;
    public currentSize: number;
    public resizeSubscription: Subscription = null;
    constructor(@Inject(PLATFORM_ID) private platformId: string, private windowResizeService: WindowResizeService) {
        this.isNode = !isPlatformBrowser(this.platformId);
    }

    ngOnInit() {}

    ngOnChanges(): void {
        if (this.items && !this.isNode) {
            this.btnLess = true;
            this.btnMore = false;
            this.currentSize = this.windowResizeService.getCurrentScreenSize();
            this.resizeSubscription = this.windowResizeService.scroll$
            .subscribe(this.handleScroll.bind(this));

            this.listenResizeWindow(this.currentSize);
        }
    }

    private listenResizeWindow(resize: number) {
        if (resize >= 1024) {
            this.indexLess = 0;
            this.indexMore = 4;
            this.deviceType = 'desktop';
        } else if (resize < 1024 && resize > 600) {
            this.indexLess = 0;
            this.indexMore = 2;
            this.deviceType = 'tablet';
        } else {
            this.indexLess = 0;
            this.indexMore = 1;
            this.deviceType = 'mobile';
        }
        this.itemsCarousel = this.items.slice(this.indexLess, this.indexMore);
    }

    ngOnDestroy(): void {
        if (this.resizeSubscription) {
            this.resizeSubscription.unsubscribe();
        }
    }

    moreItems() {
        if (this.items.length > this.indexMore) {
            this.btnLess = false;
            this.indexLess++;
            this.indexMore++;
            this.itemsCarousel = this.items.slice(this.indexLess, this.indexMore);
        } else {
            this.btnMore = true;
        }
    }

    lessItems() {
        if (this.indexLess > 0) {
            this.btnMore = false;
            this.indexLess--;
            this.indexMore--;
            this.itemsCarousel = this.items.slice(this.indexLess, this.indexMore);
        } else {
            this.btnLess = true;
        }
    }

    private handleScroll(resize: number): void {
        this.listenResizeWindow(resize);
    }
}
